import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Bell } from "lucide-react";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { buildAuthorizeUrl } from "../auth/pkce.js";
import { VizSidebar } from "../components/sidebar/viz-sidebar";
import { useUser } from "../context/user-context";
import "../index.css";

export default function Root() {
  const { user, loading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      buildAuthorizeUrl().then((url) => {
        window.location.href = url;
      });
    }
  }, [loading, user]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!user) {
    return <p>Redirecting to login...</p>;
  }

  return (
    <SidebarProvider>
      <VizSidebar />
      <div className="grid h-screen w-full ">
        <div className="flex flex-col">
          <header className="sticky top-0 z-10 flex h-[3.6rem] items-center gap-1 border-b bg-background-gray px-4 bg-navbarBackground p-3">
            <SidebarTrigger />
            <Separator orientation={"vertical"} className={"ml-2 mr-2"} />
            <h1 className="text-xl font-normal">Overview</h1>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="mt-2 rounded-lg bg-muted ml-auto"
                  aria-label="Account"
                >
                  <Bell className="size-4" color="gray" />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="left" sideOffset={5}>
                Notifications
              </TooltipContent>
            </Tooltip>
          </header>
          <main className=" flex gap-4 overflow-auto p-4 md:grid-cols-2 lg:grid-cols-3">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
